import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import academicModal from "models/academic.modal";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";

const Addacademic = () => {
  const [addsLoadig, setAddsLoadig] = useState(false);
  const navigate = useNavigate();
  const parmas = useParams();


  const location = useLocation();
  // Check if the current route matches the desired route path
  console.log("yyyyy",parmas)
  const handleSubmit = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);
    if(parmas.id){
      form.append("parentid",parmas.id);}
   
     //let type = "";
    // if (location.pathname == `/admin/academic/addacademicsub/${parmas?.id}`) {
     // alert("")
    //  form.append("type", "board");
        
    //} else if (location.pathname === `/admin/academic/class/${parmas.id}`) {
      // type = "class";
   // } else if (location.pathname === `/admin/academic/subject/${parmas.id}`) {
     //  type = "subject";
     //} else {
      // type = "academic";
     //}
     

    // You can adjust the header configuration according to your API requirements
    academicModal
      .createAcademic(form)
      .then((response) => {
        // console.log(response.data, "fqAdd");
        helper.sweetalert.toast("Your Ads add.", "success");
        if (
          location.pathname === `/admin/academic/addacademicsub/${parmas?.id}`
        ) {
          navigate(`/admin/board/${parmas?.id}`);
        } else if (location.pathname === `/admin/academic/class/${parmas.id}`) {
          navigate(`/admin/class/${parmas.id}`);
        } else if (
          location.pathname ===
          `/admin/academic/subject/${parmas.id}/${"subject"}`
        ) {
          navigate(`/admin/subjectaca/${parmas.id}`);
        } else {
          navigate(`/admin/academic`);
        }
        setAddsLoadig(false);
        // getListData();
        // toggleModal();
        // Display success message to the user
      })
      .catch((error) => {
        setAddsLoadig(false);
        // console.log(error.response?.data?.message.logo[0],"errorll")
        helper.sweetalert.toast(
          error.response?.data?.message.logo[0],
          "warning"
        );
        // console.log(error);
      });
  };

  console.log(parmas.name, "locatiosdffs");

  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">
                  {location.pathname ===
                  `/admin/academic/addacademicsub/${parmas?.id}` ? (
                    <span>Add board</span>
                  ) : location.pathname ===
                    `/admin/academic/class/${parmas?.id}` ? (
                    <span>Add class</span>
                  ) : location.pathname ===
                    `/admin/academic/subject/${parmas?.id}/${"subject"}` ? (
                    <span>Add Subject</span>
                  ) : (
                    <span>Add Academic</span>
                  )}
                </h3>
              </CardHeader>

              <CardBody>
                <div>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Name</Label>
                          <Input name="name" placeholder="Enter Name" />
                        </FormGroup>
                      </Col>
                      {parmas.name == "subject" ? null : (
                        <Col md={6}>
                          <FormGroup>
                            <Label>Sub-Category Title</Label>
                            <Input
                              id="name"
                              name="title"
                              placeholder="Enter Sub-Category Title"
                            />
                          </FormGroup>
                        </Col>
                      )}
                      
                      {/* <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Type</Label>
                          <Input id="forType" name="type" type="select">
                            <option value="">select option</option>
                            <option value="Academic">Academic</option>
                            <option value="Board">Board</option>
                            <option value="Class">Class</option>
                            <option value="Subject">Subject</option>
                          </Input>
                        </FormGroup>
                     

                    <Row style={{ display: "none" }}>
                      {parmas?.id && (
                        <Col md={6}>
                          <FormGroup>
                            <Label for="exampleEmail">Parentid</Label>
                            <Input
                              id="parentid"
                              name="parentid"
                              type="number"
                              placeholder="Enter Parentid"
                              defaultValue={parmas.id}
                            />
                          </FormGroup>
                        </Col>
                      )}

                      {/* <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Type</Label>
                          <Input id="forType" name="forType" type="select">
                            <option value="driver">select option</option>
                            <option value="user">Tutor</option>
                            <option value="both">Student</option>
                          </Input>
                        </FormGroup>
                      </Col> */}
                    </Row>

                    <Row>
                    
                        <Col md={6}>
                          <FormGroup>
                            <Label>vacancy Available</Label>
                            <Input
                              type="select"
                              id="name"
                              name="vacancyavailable"
                              placeholder="Enter Sub-Category Title"
                            >
                              <option value="false">False</option>
                              <option value="true">True</option>
                            </Input>
                          </FormGroup>
                        </Col>
                    
                      <Col md={6}>
                        <FormGroup>
                          <Label>Icon</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            id="name"
                            name="logo"
                            type="file"
                          />
                        </FormGroup>
                      </Col>
                      {/* <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">step</Label>
                          <Input type="select">
                            <option value="">select</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                          </Input>
                        </FormGroup>
                      </Col> */}
                    </Row>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        color="secondary"
                        onClick={() => {
                          let newPath = "/admin/academic"; // Default path
                          switch (location.pathname) {
                            case `/admin/academic/addacademicsub/${parmas?.id}`:
                              newPath = `/admin/board/${parmas?.id}`;
                              break;
                            case `/admin/academic/class/${parmas?.id}`:
                              newPath = `/admin/class/${parmas?.id}`;
                              break;
                            case `/admin/academic/subject/${
                              parmas?.id
                            }/${"subject"}`:
                              newPath = `/admin/subjectaca/${parmas?.id}`;
                              break;
                            default:
                              newPath = "/admin/academic";
                              break;
                          }
                          navigate(newPath);
                        }}
                      >
                        Cancel
                      </Button>

                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : (
                        <Button
                          color="primary"
                          type="submit"
                          style={{
                            float: "right",
                            marginLeft: "5%",
                            backgroundColor: "#080278",
                            color: "white",
                          }}
                        >
                          Save
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Addacademic;
